import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class CircleBar extends Component{
  render() {
    return (
      <span ref="progressCircle" className="progress-circle progress-circle-animate"
            data-progress={this.props.score || 0}>
            <span><em/></span><span><em/></span>
      </span>
    )
  }
}

CircleBar.propTypes = {
  score: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/CircleBar/index.js